import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import AdminMfaResetPage from "@/pages/admin/AdminMfaResetPage";

export const Route = createFileRoute("/_admin/admin/mfa-reset")({
  head: () => pageHead("Admin · Mfa Reset", "AKIVA admin · mfa reset portal.", "/admin/mfa-reset", true),
  component: AdminMfaResetPage,
});
